// extracted by mini-css-extract-plugin
export default {"root":"VnMv9","option":"CSPzN"};